export default "__VITE_ASSET__COb$Xddb__"